var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.slider,style:({
  '--transition-duration': (_vm.transition + "ms"),
  '--direction': ("" + _vm.direction)
  })},[(_vm.slides)?[_c('transition',{attrs:{"name":"slider"}},[_c('Slide',{key:_vm.slide.id,attrs:{"slide":_vm.slide},on:{"next":_vm.nextSlide,"prev":_vm.prevSlide}},[_vm._t("default",null,{"currentSlide":_vm.currentSlide,"methods":{ nextSlide: _vm.nextSlide, prevSlide: _vm.prevSlide },"slide":_vm.slide})],2)],1)]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }